import { Component, OnInit, EventEmitter, Output ,Pipe, PipeTransform, ViewChild, ElementRef, TemplateRef} from '@angular/core';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Subscription, Observable } from 'rxjs';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { GetDocumentDetails } from 'src/app/viewModels/core/delete-document-req-vm';
import { DomSanitizer, SafeUrl, SafeResourceUrl  } from '@angular/platform-browser';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { map, startWith } from 'rxjs/operators';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { MatChipInputEvent } from '@angular/material/chips';
import { Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import heic2any from "heic2any";
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
declare var require: any;
const FileSaver = require('file-saver');
@Component({
  selector: 'app-document-viewers',
  templateUrl: './document-viewers.component.html',
  styleUrls: ['./document-viewers.component.scss']
})

export class DocumentViewersComponent implements OnInit {
  viewer = 'google';
  organizationId: string;
  OfficeIDList: any=[];
  myOfficeID: any;
  databaseId: string;
  currentUser: any;
  showDetail:boolean = false;
  CloseViewDocument:boolean = false;  
  responseHolder: any;
  selectedImagetoShow: any;
  
  @Output() getCloseDocumentViewer = new EventEmitter<boolean>();
  spinner:boolean=false;
  @Output() documentViewer = new EventEmitter<boolean>();
 // documentType:any;
 // documentpath:any;
  //documentName:string="";
  @Input() documentpath :string="";
  @Input() documentType :string="";
  @Input() documentName:string="";
  constructor(private formsService: FormsService,
    private dialog: MatDialog,
    private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private _dataSharingService: DataSharingService,
    private statusConst: StatusConstant, public sanitizer: DomSanitizer,
    private formBuilder: FormBuilder, private toastr: ToastrService,
    private settingsService: SettingService,private loaderService: LoaderService) {     
      
  }


  ngOnInit(): void {    
    if(this.documentType=='heic'){
      this.getHEICFile(this.documentName,this.documentpath);
     }  
  }


  b64toBlob(b64Data, contentType='', sliceSize=512){
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
  
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

   blobToBase64 = blob => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise(resolve => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  };

  getHEICFile(fileName:any,url:any) {
    this.formsService.getAttachment(fileName,url).subscribe((response) => {
      if (response !== undefined) {
        const data = 'data:' + response.data.contentType + ';base64,' + response.data.base64URL;
        let blobfile=this.b64toBlob(response.data.base64URL,response.data.contentType);
       (heic2any({
            blob:blobfile,
            toType:"image/jpeg",
            quality: 0.5
          })).then((conversionResult) => {
              this.blobToBase64(conversionResult).then(res => {               
                this.loaderService.hide();
                this.selectedImagetoShow=res;
              });
            });
      }else{
        this.toastr.error('File download failed.', '', {
          timeOut: 3000,
        });
      }
    });
  }
 
  getReadableFileSizeString(fileSizeInBytes) {
    var i = -1;
    var byteUnits = [' KB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
        fileSizeInBytes = fileSizeInBytes / 1024;
        i++;
    } while (fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes).toFixed(3) + byteUnits[i];
  };
   
  opendocdetail(){
    this.showDetail = !this.showDetail
  }
  
  close() {  
    this.dialog.closeAll();
  }
 
  CloseDocumentViewer(message:boolean){   
    this.getCloseDocumentViewer.emit(message);
  }

  DownloadFile() {  
    this.spinner=true;
    this.formsService.getAttachment(this.documentName, this.documentpath).subscribe((response) => {
    if (response !== undefined) {
        const data = 'data:' + response.data.contentType +';base64,' + response.data.base64URL;
        FileSaver.saveAs(data, this.documentName);
        this.spinner=false;
       }else{
        this.spinner=false;
       }
    });
  }
}
